import './LeadInquiryInfoModal.scss'
import './LeadSources.scss'

import React, { Component } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { connectModal } from 'redux-modal'
import moment from 'moment-timezone'
import { fetchLeadInquiry, resetLeadInquiry } from 'broker/redux/inquiry_modal'

import { ASSIGNMENTS, BUYER_TYPE, DISPLAY_PRICE, SHORT_LEAD_TYPE } from 'common/constants'

import {
  labelFor
} from 'common/util/helper'

import { segmentEventTracker } from 'common/analytics'

const AGENT_STAUS_ORDER = {
  'filtered': 0,
  'eligible': 1,
  'sent': 2,
  'clicked': 3,
  'won': 4,
  'won-no-answer': 4,
  'won-busy': 5,
  'won-no-accept': 6,
  'won-accept': 7,
}

class LeadInquiryInfo extends Component {

  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      agentsExpanded: false,
    }

  }

  componentWillMount() {
    const { props } = this

    props.dispatch(resetLeadInquiry(
      props.arrived_at,
      props.name,
      props.email,
      props.phone,
      props.source,
      props.source_type,
      props.source_key,
      props.logo_url,
      props.stage,
      props.resolution,
      props.is_duplicate,
      props.market,
      props.zipcode,
      props.price_category,
      props.likelihood_category,
      props.client_category,
      props.agent_name,
      props.agent_email,
      props.agent_phone,
      props.broker,
      props.network_referral,
      props.hide_contact_details,
      props.transactions,
      props.pending_close_transactions,
      props.paid_close_transactions,
      props.released_transactions,
      props.release_agent_name,
      props.lead_inquiry_hash,
      props.primary_lead_inquiry_hash,
      props.primary_lead_inquiry_arrived_at,
    ))

    props.dispatch(fetchLeadInquiry(props.initialState.lead_inquiry_hash))
      .then(() => {this.setState({loading: false})})
  }

  handleClickForSegmentEvent = (item, eventName, otherSegmentProperties) => {
    const { searchFiltersForSegmentExport, excludeDuplicates } = this.props

    const baseSegmentProperties = {
      'transaction_agent_user_hash': item.agent_user_hash,
      'transaction_likelihood_category': item.likelihood_category,
      'lead_inquiry_stage': item.stage,
      'lead_inquiry_external_id': item.primary_lead_inquiry_hash,
      'lead_inquiry_is_duplicate': item.is_duplicate,
      'lead_inquiry_transactions': item.transaction,
      'lead_inquiry_owned_by_brokerage': item.owns_lead,
      'lead_inquiry_price_category': item.price_category,
      'lead_inquiry_client_category': item.client_category,
      'search_filters_exclude_duplicates': excludeDuplicates,
      'lead_source_name': item.source,
      'lead_source_type': item.source_type
    }

    segmentEventTracker(eventName,{
      ...baseSegmentProperties,
      ...searchFiltersForSegmentExport,
      ...otherSegmentProperties
    })
  }

  render() {

    const { props } = this
    const { inquiryModal } = this.props
    const isDupe = inquiryModal.is_duplicate
    const loading = this.state.loading

    let agents = inquiryModal.agent_statuses
    if (agents) {
      agents.forEach((item) => {
        let status = ''
        if (item.has_blocks) {
          status = 'Filtered'
        } else {
          if (item.dispatch_sent_at) {
            if (item.dispatch_claimed_by_client_at) {
              status = 'Clicked'
            } else {
              status = 'Sent'
            }
          } else {
            status = 'Eligible'
          }
        }

        if (item.resolution) {
          status = 'Won'
        }

        let orderKey = status.toLowerCase()

        let resolution = null
        if (status == 'Won' && item.resolution) {
          resolution = labelFor(ASSIGNMENTS, item.resolution)

          if (resolution !== 'N/A') {
            orderKey += '-'
            orderKey += item.resolution
          }
        }
        item['statusLabel'] = status
        item['resolutionLabel'] = resolution
        item['order'] = AGENT_STAUS_ORDER[orderKey] ? AGENT_STAUS_ORDER[orderKey] : 0
      })

      agents = agents.sort((a,b) => {
        let order = b['order'] - a['order']
        if (order === 0) {
          return a['rank'] - b['rank']
        }
        return order
      })
    }

    const renderAgent = (item) => {
      let status = item.statusLabel
      let resolution = ''
      if (item.resolutionLabel) {
        resolution += ' - '
        resolution += item.resolutionLabel
      }

      return (
        <div className="LeadInquiryInfoModal__agent">
          <div className="LeadInquiryInfoModal__agent-name">{item.name}</div>
          <div className="LeadInquiryInfoModal__agent-status">{status}{resolution}</div>
        </div>
      )
    }

    const logoClasses = ['LeadInquiryInfoModal__logo', 'LeadSourceTablet__title-sec--logo', `LeadSourceTablet__title-sec--logo--${inquiryModal.source_key}`]

    return (
      <Modal show={props.show} className="LeadInquiryInfoModal__modal">
        <div className="LeadSources__modal__close-x" onClick={props.handleHide}><div></div></div>
        <Modal.Header bsClass="LeadInquiryInfoModal__modal">
          <div className="LeadInquiryInfoModal__header">
            <div>
              <div className="LeadInquiryInfoModal__header--title">Lead Details</div>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="LeadInquiryInfoModal__lead-section">
            <div className="LeadInquiryInfoModal__lead">
              <div className={logoClasses.join(' ')}>
                <div style={{backgroundImage: `url(${inquiryModal.logo_url})`}}>{!inquiryModal.logo_url ? <div>OS</div> : null }</div>
              </div>
              <div className="LeadInquiryInfoModal__source-type">{inquiryModal.source_type}</div>
              <div className="LeadInquiryInfoModal__small">{inquiryModal.source}</div>
              <div className="LeadInquiryInfoModal__small">{moment.utc(inquiryModal.arrived_at).local().format("MM-DD-YY h:mm A")}</div>
              <div className="LeadInquiryInfoModal__small">#{inquiryModal.lead_inquiry_hash}</div>
            </div>
            <div className="LeadInquiryInfoModal__lead">
              <div>{ inquiryModal.name }</div>
              <div className="LeadInquiryInfoModal__small">{ inquiryModal.email ? inquiryModal.email : 'No Email Address' }</div>
              <div className="LeadInquiryInfoModal__small">{ inquiryModal.phone ? inquiryModal.phone : 'No Phone Number' }</div>
            </div>
          </div>
          <div className="LeadInquiryInfoModal__meta_section">
            <div className="LeadInquiryInfoModal__meta">
              <div className="LeadInquiryInfoModal__smallest">Zip Code</div>
              <div className="LeadInquiryInfoModal__meta-text">{ inquiryModal.zipcode ? inquiryModal.zipcode : 'N/A' }</div>
              <div className="LeadInquiryInfoModal__smallest">Price Range</div>
              <div className="LeadInquiryInfoModal__meta-text">{ inquiryModal.price_category ? labelFor(DISPLAY_PRICE, inquiryModal.price_category) : 'N/A' }</div>
            </div>
            <div className="LeadInquiryInfoModal__meta">
              <div className="LeadInquiryInfoModal__smallest">Timeframe</div>
              <div className="LeadInquiryInfoModal__meta-text">{ inquiryModal.likelihood_category ? labelFor(SHORT_LEAD_TYPE, inquiryModal.likelihood_category) : 'N/A' }</div>
              <div className="LeadInquiryInfoModal__smallest">Type</div>
              <div className="LeadInquiryInfoModal__meta-text">{ inquiryModal.client_category ? labelFor(BUYER_TYPE, inquiryModal.client_category) : 'N/A' }</div>
            </div>

          </div>
          <div className="LeadInquiryInfoModal__stage-section">
            <div className="LeadInquiryInfoModal__stage">
              <div className="LeadInquiryInfoModal__stage-title">{ !isDupe ? inquiryModal.stage : 'Duplicate' }{ !isDupe && inquiryModal.stage == 'Referred' && inquiryModal.network_referral ? ' (Network)' : '' }</div>
              { isDupe && inquiryModal.primary_lead_inquiry_arrived_at ? <div className="LeadInquiryInfoModal__small">Original at { moment.utc(inquiryModal.primary_lead_inquiry_arrived_at).local().format("MM-DD-YY h:mm A") }</div> : null }
              { !isDupe ? <div className="LeadInquiryInfoModal__small">{ inquiryModal.resolution }</div> : null }
              { !isDupe && inquiryModal.transactions && !inquiryModal.network_referral ? <div className="LeadInquiryInfoModal__small">{ inquiryModal.transactions } Assigned Transaction(s)</div> : null }
              { !isDupe && inquiryModal.pending_close_transactions && !inquiryModal.network_referral ? <div className="LeadInquiryInfoModal__small">{ inquiryModal.pending_close_transactions } Closed Transaction(s) (Pending Payment)</div> : null }
              { !isDupe && inquiryModal.paid_close_transactions && !inquiryModal.network_referral ? <div className="LeadInquiryInfoModal__small">{ inquiryModal.paid_close_transactions } Closed Transaction(s) (Paid)</div> : null }
              { !isDupe && inquiryModal.released_transactions && !inquiryModal.network_referral ? <div className="LeadInquiryInfoModal__small">{ inquiryModal.released_transactions } Released Transaction(s)</div> : null }
              { !isDupe && inquiryModal.transactions && inquiryModal.network_referral ? <div className="LeadInquiryInfoModal__small">{ inquiryModal.transactions } Assigned Transaction(s) (Network)</div> : null }
              { !isDupe && inquiryModal.paid_close_transactions && inquiryModal.network_referral ? <div className="LeadInquiryInfoModal__small">{ inquiryModal.paid_close_transactions } Closed Transaction(s) (Network)</div> : null }
              { !isDupe && inquiryModal.release_agent_name ? <div className="LeadInquiryInfoModal__small">Released by { inquiryModal.release_agent_name }</div> : null }
            </div>
            <div className="LeadInquiryInfoModal__stage">
              <div className="LeadInquiryInfoModal__name">{ inquiryModal.agent_name }</div>
              { inquiryModal.agent_email ? <div className="LeadInquiryInfoModal__vendor-contact">{ inquiryModal.agent_email }</div> : null }
              { inquiryModal.agent_phone ? <div className="LeadInquiryInfoModal__vendor-contact">{ inquiryModal.agent_phone }</div> : null }
              {
                inquiryModal.loan_broker_company ? <div className="LeadInquiryInfoModal__vendor">
                  <div className="LeadInquiryInfoModal__vendor-title">Partner Loan Officer</div>
                  <div className="LeadInquiryInfoModal__name">{ inquiryModal.loan_officer_name }</div>
                  <div className="LeadInquiryInfoModal__vendor-contact">{ inquiryModal.loan_broker_profile_name ? inquiryModal.loan_broker_profile_name : inquiryModal.loan_broker_company }</div>
                  <div className="LeadInquiryInfoModal__vendor-contact">{ inquiryModal.loan_officer_email }</div>
                  <div className="LeadInquiryInfoModal__vendor-contact">{ inquiryModal.loan_officer_phone_formatted }</div>
                </div> : null
              }
              {
                inquiryModal.settlement_broker_company ? <div className="LeadInquiryInfoModal__vendor">
                  <div className="LeadInquiryInfoModal__vendor-title">Partner Settlement Officer</div>
                  <div className="LeadInquiryInfoModal__name">{ inquiryModal.settlement_officer_name }</div>
                  <div className="LeadInquiryInfoModal__vendor-contact">{ inquiryModal.settlement_broker_profile_name ? inquiryModal.settlement_broker_profile_name : inquiryModal.settlement_broker_company }</div>
                  <div className="LeadInquiryInfoModal__vendor-contact">{ inquiryModal.settlement_officer_email }</div>
                  <div className="LeadInquiryInfoModal__vendor-contact">{ inquiryModal.settlement_officer_phone_formatted }</div>
                </div> : null
              }
            </div>
          </div>
          <div className="LeadInquiryInfoModal__contact-section">
            <div className="LeadInquiryInfoModal__contact">
              {
                loading ? <div className="LeadInquiryInfoModal__loading-large pulse"/> :
                  <div><i className="fa fa-phone"/><span>Called { inquiryModal.call_count ? inquiryModal.call_count : 0 } time(s)</span></div>
              }
            </div>
            <div className="LeadInquiryInfoModal__contact">
              {
                loading ? <div className="LeadInquiryInfoModal__loading-large pulse"/> :
                  <div><i className="fa fa-comment-o"/><span>Texted { inquiryModal.sms_count ? inquiryModal.sms_count : 0 } time(s)</span></div>
              }
            </div>
          </div>
          <div className="LeadInquiryInfoModal__dispatch_section">
            <div className="LeadInquiryInfoModal__dispatch">
              {
                loading ? <div className="pulse"><div className="LeadInquiryInfoModal__loading-large"/><div className="LeadInquiryInfoModal__loading-small"/></div> :
                  <div>
                    <div className="LeadInquiryInfoModal__dispatch-title">Agent Dispatches</div>
                    { agents && agents.length > 0 ? <a onClick={() => {
                      this.handleClickForSegmentEvent(this.props, 'Modal Shown', {
                        'modal_name': 'LeadInquiryInfoModalDispatch',
                        'lead_inquiry_agent_dispatches': agents.length
                      })

                      this.setState({agentsExpanded:!this.state.agentsExpanded})
                    }}>{this.state.agentsExpanded ? 'Hide' : 'Show'} {agents.length} agents</a> : null }
                  </div>
              }
            </div>
            <div className="LeadInquiryInfoModal__dispatch">
              {
                loading ? <div className="LeadInquiryInfoModal__loading-small pulse"/> :
                  <div>
                    <div>Ran { inquiryModal.dispatch_times ? inquiryModal.dispatch_times.length : 0 } time(s)</div>
                    { inquiryModal.dispatch_times ? inquiryModal.dispatch_times.map((time) => <div className="LeadInquiryInfoModal__small">{ moment.utc(time).local().format("MM-DD-YY h:mm A") }</div>) : null }
                  </div>
              }
            </div>
          </div>
          {
            this.state.agentsExpanded ? <div className="LeadInquiryInfoModal__agents">
              { agents ? agents.map(renderAgent) : null }
            </div> : null
          }
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.handleHide} bsStyle="default">Close</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

const LeadInquiryInfoModal = connectModal({ name: 'LeadInquiryInfoModal', destroyOnHide: true })(LeadInquiryInfo)
export default LeadInquiryInfoModal
